import { z } from 'zod';

import { BaseLoanEvent } from './BaseLoanEvent';

export const SendFinalPaymentEmailEvent = BaseLoanEvent.extend({
  type: z.literal('sendFinalPaymentEmail'),
});
export type SendFinalPaymentEmailEvent = z.infer<typeof SendFinalPaymentEmailEvent>;
